import { getForClient, postForClient } from '../../../api/request';

// https://papi.sankuai.com/index/#/papi/project/e08ab93f-b2ca-41a1-b671-941c965ba4e4?apiId=5895dbd3-7ecc-448e-9306-ac01bc9f7d04

interface Response {
  message: string;
  code: number;
  data: Array<string>;
}

interface QueryBrandParams {
  brand: string;
  city: string;
  lanType: string;
}
// 查询响应信息
export const queryBrandList = async (params: QueryBrandParams) => {
  const data = await getForClient<QueryBrandParams, Response>(
    '/smart/view/business/r/tbusinesscontactinfoservice_searchbrand',
    params,
  );
  const { code, message, data: respData } = data;
  if (code === 0) {
    return respData;
  }
  throw message;
};

type QueryCityParams = Omit<QueryBrandParams, 'brand'>;
// 查询响应信息
export const queryCityList = async (params: QueryCityParams) => {
  const data = await getForClient<QueryCityParams, Response>(
    '/smart/view/business/r/tbusinesscontactinfoservice_searchcity',
    params,
  );
  const { code, message, data: respData } = data;
  if (code === 0) {
    return respData;
  }
  throw message;
};

interface InParams {
  businessType: string;
  brandName: string;
  contactName: string;
  contactPhone: string;
}
// 查询响应信息
export const createBrandItem = async (params: InParams) => {
  const data = await postForClient<InParams, Response>('/smart/view/business/w/createContactInfo', params);
  const { code, message, data: respData } = data;
  if (code === 0) {
    return respData;
  }
  throw message;
};
